import axios from 'axios';
import { nanoid } from 'nanoid';
import { isQueryError } from './query-error';
import { invalidateDimensionsQuery, invalidateCriticalEventsQuery } from '../queries';

export const axiosInstance = axios.create({
  baseURL: BUILD_VARS.QUERY_DOMAIN,
  timeout: 5 * 60 * 1000,
  withCredentials: true,
  adapter: ['fetch', 'xhr'],
});

axiosInstance.interceptors.request.use((req) => {
  req.headers['x-cvv-trace-id'] = nanoid();

  return req;
});

axiosInstance.interceptors.response.use(undefined, (error) => {
  if (isQueryError(error) && [401, 403].includes(error.response.status)) {
    window.location.href = '/login';

    return;
  }

  if (isQueryError(error, 40402)) {
    const { dimensions, events } = error.response.data.data ?? {};

    if (dimensions?.length) {
      void invalidateDimensionsQuery(dimensions);
    }

    if (events?.length) {
      void invalidateCriticalEventsQuery(events);
    }
  }

  if (error.response?.data?.message) {
    error.message = error.response.data.message;
  }

  throw error;
});
